import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const items = t('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <section id="faq" className="py-20 lg:py-28 bg-white" data-id="element-128">
      <div className="container mx-auto px-6" data-id="element-129">
        <div className="grid lg:grid-cols-12 gap-16 max-w-6xl mx-auto" data-id="element-130">
          {/* Left: heading */}
          <div className="lg:col-span-4" data-id="element-131">
            <div className="lg:sticky lg:top-32" data-id="element-132">
              <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-133">
                {t('faq.eyebrow')}
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-134">
                {t('faq.heading')}
              </h2>
              <div className="w-12 h-px bg-brand-gold mb-6" data-id="element-135"></div>
              <p className="text-brand-dark/60 font-light leading-relaxed" data-id="element-136">
                {t('faq.subheading')}
              </p>
            </div>
          </div>

          {/* Right: accordion */}
          <div className="lg:col-span-8" data-id="element-137">
            <div className="divide-y divide-brand-stone/50" data-id="element-138">
              {items.map((item: any, idx: number) => {
              const isOpen = openIndex === idx;
              return <motion.div key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.6,
                delay: idx * 0.05,
                ease: easeOutCubic
              }} data-id="element-139">
                    <button onClick={() => toggle(idx)} className="w-full flex items-start justify-between gap-8 py-7 text-left group" aria-expanded={isOpen} data-id="element-140">
                      <span className="font-serif text-lg lg:text-xl text-brand-dark font-light group-hover:text-brand-ink transition-colors flex-1" data-id="element-141">
                        {item.q}
                      </span>
                      <span className="shrink-0 mt-1 text-brand-dark/40 group-hover:text-brand-gold transition-colors" data-id="element-142">
                        {isOpen ? <MinusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-143" /> : <PlusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-144" />}
                      </span>
                    </button>
                    <AnimatePresence data-id="element-145">
                      {isOpen && <motion.div initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} exit={{
                    opacity: 0,
                    height: 0
                  }} transition={{
                    duration: 0.4,
                    ease: easeOutCubic
                  }} className="overflow-hidden" data-id="element-146">
                          <p className="pb-7 pr-12 text-brand-dark/65 font-light leading-relaxed" data-id="element-147">
                            {item.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}